import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import styles from './Loading.module.css'; // Only keep this if needed

function Loading() {
  return (
    <div className={styles.loadingContainer} >
      <TailSpin
        visible={true}
        height="80"
        width="80"
        color="#72a1ed" // Light blue works well on dark bg
        ariaLabel="tail-spin-loading"
      />
    </div>
  );
}

export default Loading;
